import * as React from 'react';

import { PlayFillInBlankQuestion } from '../../../Shared';
import { storeResponseInAttempts } from '../../actions/diagnostics.js';
import { getGradedResponsesWithCallback, saveResponseToCMS } from '../../actions/responses.js';
import { Question } from '../../interfaces/Question';
import { DIAGNOSTIC } from '../../../Shared/utils/constants';

interface PlayFillInTheBlankQuestionProps {
  currentKey: string;
  diagnosticID: string;
  dispatch(action: any): any;
  isLastQuestion: boolean;
  language: string;
  nextQuestion(): any;
  previewMode: boolean;
  question: Question;
  setResponse(response: any): any;
  translate(key: any, opts?: any): any;
}

export class PlayFillInTheBlankQuestionWrapper extends React.Component<PlayFillInTheBlankQuestionProps> {
  submitQuestionResponseWrapper = (response: any) => {
    const action = storeResponseInAttempts(response);
    this.props.dispatch(action);
  };

  updateResponseResourceWrapper = (returnValue: any, questionID: string, attempts: any, dispatch: any) => {
    const latestAttempt = attempts[attempts.length - 1];
    const isFirstAttempt = !latestAttempt;
    dispatch(saveResponseToCMS(returnValue.response, isFirstAttempt));
  };

  render() {
    return (
      <PlayFillInBlankQuestion
        {...this.props}
        getGradedResponsesWithCallback={getGradedResponsesWithCallback}
        mode={DIAGNOSTIC}
        submitResponse={this.submitQuestionResponseWrapper}
        updateResponseResource={this.updateResponseResourceWrapper}
      />
    );
  }
}

export default PlayFillInTheBlankQuestionWrapper;
